import { default as AkFlag, type FlagProps as AkFlagProps } from '@atlaskit/flag';

import { wrapComponentForChoreographer } from '../utils';

export const Flag = wrapComponentForChoreographer<AkFlagProps>(AkFlag);
